require('./associatedCards.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ helpers
const { getAssociatedCardOwner } = require('utilities/cardsHelper');

// @ commons
const { EMPTY_CONCEPT } = require('constants/index')
const { FormattedText, formatText } = require('core/i18n').i18n;
const { EmptyState } = require('commonsComponents/emptyState');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell} = require('commonsComponents/OKTableCell');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @constants
const { CARD_INTERVENTION_OWNER } = require('constants/index');

class AssociatedCards extends React.Component {

    getAssociatedCards() {
        const { immCards, immCard } = this.props;
        const contract = immCard.getIn(['contract', 'number']);
        const product = immCard.getIn(['contract', 'product']);
        const pan = immCard.get('number');

        const immListCards = immCards.get('byId');
        let associatedCards = [];

        if (immListCards) {
            immListCards.forEach(immTmpCard => {
                const tmpContract = immTmpCard.getIn(['contract', 'number']);
                const tmpProduct = immTmpCard.getIn(['contract', 'product']);
                const tmpPan = immTmpCard.get('number');

                if (pan !== tmpPan &&
                    (contract === tmpContract && product === tmpProduct)) {
                    associatedCards.push({
                        pan: tmpPan || EMPTY_CONCEPT,
                        status: immTmpCard.get('status') || EMPTY_CONCEPT,
                        owner: getAssociatedCardOwner(immTmpCard),
                    });
                }
            });
        }

        return associatedCards;
    }

    buildEmptyCardsContent() {
        return (<EmptyState primaryText={formatText('customCardDetails-emptyAssociatedCards')} />);
    }

    headers() {
        return (
            <OKTableRow asHeader={true}>
                <OKTableCell className="associated-cards__table-header" asHeader={true}>
                    <FormattedText value="customCardDetails-associatedCardsPan" />
                </OKTableCell>
                <OKTableCell className="associated-cards__table-header" asHeader={true}>
                    <FormattedText value="customCardDetails-associatedCardsStatus" />
                </OKTableCell>
                <OKTableCell className="associated-cards__table-header" asHeader={true}>
                    <FormattedText value="customCardDetails-associatedCardsOwner" />
                </OKTableCell>
            </OKTableRow>
        );
    }

    getCardStatusTranslation(status) {
        const translation = `card-status${status}`;
        return translation || status;
    }

    buildAssociatedCardsRows(associatedCards) {
        return associatedCards.map((associatedCard, key) => {
            return (
                <OKTableRow key={key}>
                    <OKTableCell className="associated-cards__table-cell-pan">{ associatedCard.pan }</OKTableCell>
                    <OKTableCell className="associated-cards__table-cell-status">
                        <FormattedText value={this.getCardStatusTranslation(associatedCard.status)}/>
                    </OKTableCell>
                    <OKTableCell>{ associatedCard.owner }</OKTableCell>
                </OKTableRow>
            );
        });
    }

    buildAssociatedCardsContent(associatedCards) {
        return (
            <OKTable className="associated-cards__table">
                <thead>{ this.headers() }</thead>
                <tbody>{ this.buildAssociatedCardsRows(associatedCards) }</tbody>
            </OKTable>);
    }

    buildAssociatedCards() {
        const associatedCards = this.getAssociatedCards();
        return associatedCards.length === 0 ? this.buildEmptyCardsContent() : this.buildAssociatedCardsContent(associatedCards);
    }

    isContractOwner() {
        const { immCards, immCard } = this.props;
        const contract = immCard.getIn(['contract', 'number']);
        const product = immCard.getIn(['contract', 'product']);
        let contractOwner = false;

        const immListCards = immCards.get('byId');
        if (immListCards) {
            contractOwner = immListCards.some(immTmpCard => {
                const tmpContract = immTmpCard.getIn(['contract', 'number']);
                const tmpProduct = immTmpCard.getIn(['contract', 'product']);

                return ((contract === tmpContract && product === tmpProduct) && immTmpCard.get('interventionType') === CARD_INTERVENTION_OWNER);
            });
        }

        return contractOwner;
    }

    render() {
        if (this.isContractOwner()) {
            return (
                <OKInformativeList title="customCardDetails-associatedCardsTitle" columns={1}>
                    <OKInformativeListItem>{ this.buildAssociatedCards() }</OKInformativeListItem>
                </OKInformativeList>);
        } else {
            return null;
        }
    }
}

AssociatedCards.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired
};

module.exports = AssociatedCards;
